import template from './shipment_record.html';
import shipmentRecordLink from './shipment_record.link';

let shipmentRecordComponent = [() => {
  return {
    restrict: 'EA',

    scope: {
      model: '=recordModel',
      currency: '=',
      currenctTotal: '=',
      onTab: '&',
      onRemove: '&',
      onCreateLocation: '&',
      onUpdateLocation: '&',
      batchMaster: '=',
      isRoutesSet: '=',
      duplicateTrackingIds: '=',
      showBankLocationDd: '=',
      bankLocations: '=bankLocations',
      denominationTypeObj: '=denominationTypeObj',
      amountToggle: '=',
      coinValues: '=',
      coinOnlyBatch: '=',
      isGenerateTrackingIdLoading:'='
    },
    template,
    link: shipmentRecordLink
  }
}];

export default shipmentRecordComponent;

     


// WEBPACK FOOTER //
// ./client/app/components/shipment_batch/shipment_record/shipment_record.directive.js